import enLang from './entries/en-US';
import deLang from './entries/de_DE';
import { addLocaleData } from 'react-intl';

const AppLocale = {
	en: enLang,
	de: deLang
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.de.data);

export default AppLocale;



// WEBPACK FOOTER //
// ./lngProvider/index.js